<template>
  <base-content>
    <template v-slot:top>
      <hero-header heading="Pay Deposit" />
    </template>
    <template v-if="error">
      <div class="alert alert-danger">
        {{ error }}
      </div>
      <base-button :to="{ name: 'account.payment', params: { account: account._id } }">
        Back to payment details
      </base-button>
    </template>
    <template v-if="requested && account.depositMethod === 'BankTransfer'">
      <p class="mb-4 pb-4">
        Use the information below to pay for your investment. When you make a payment it is
        essential that you use the Unique Reference provided. Failure to do so may lead to delays
        in allocating your investment. Please take into account any payment fees that your bank may
        charge. Your bank will set the exchange rate for currency conversions.
      </p>
      <div class="row justify-content-center">
        <div class="col-md-6">
          <base-table>
            <colgroup>
              <col width="50%" />
              <col width="50%" />
            </colgroup>
            <tbody>
              <tr>
                <th class="text-right">Amount</th>
                <td>{{ $formatting.toCurrency(bankwire.amount) }}</td>
              </tr>
              <!-- <tr>
                <th class="text-right">Bank</th>
                <td>{{ bankwire.bankName }}</td>
              </tr> -->
              <tr>
                <th class="text-right">Account Name</th>
                <td>Saxon Trust</td>
              </tr>
              <tr>
                <th class="text-right">Unique Reference</th>
                <td>{{ bankwire.reference }}</td>
              </tr>
              <!-- <tr>
                <th class="text-right">Account Number</th>
                <td>{{ bankwire.accountNumber }}</td>
              </tr>
              <tr>
                <th class="text-right">Sort Code</th>
                <td>{{ bankwire.sortCode }}</td>
              </tr> -->
              <tr>
                <th class="text-right">IBAN</th>
                <td>{{ bankwire.iban }}</td>
              </tr>
              <tr>
                <th class="text-right">BIC</th>
                <td>{{ bankwire.bic }}</td>
              </tr>
            </tbody>
          </base-table>
        </div>
      </div>
    </template>
    <template v-else-if="!requested">
      <base-loader />
    </template>
  </base-content>
</template>

<script>
import { mapState } from 'vuex'
import { PaymentHandler } from '@/mixins'

import HeroHeader from '@/components/HeroHeader.vue'

export default {
  async created () {
    await this.makePayment()
  },

  data: () => ({
    requested: false
  }),

  components: {
    HeroHeader
  },

  mixins: [PaymentHandler],

  computed: {
    ...mapState({
      account: store => store.core.accounts.entity,
      bankwire: store => store.core.bankwires.entity,
      error: store => store.core.payments.error
    })
  },

  methods: {
    async makePayment () {
      await this.$store.dispatch('core/accounts/get', this.$route.params.id)

      this.amount = this.account.initialDeposit

      if (this.account.depositMethod === 'DebitCard') {
        await this.creditViaCard()
      } else if (this.account.depositMethod === 'BankTransfer') {
        if (this.account.depositRequested) {
          await this.$store.dispatch('core/bankwires/get', this.account.depositBankwire)
        } else {
          await this.payViaBankwire()

          await this.$store.dispatch('core/accounts/update', {
            _id: this.account._id,
            depositBankwire: this.bankwire._id,
            depositRequested: true
          })
        }

        this.requested = true
      }
    }
  }
}
</script>
